var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCopycontent(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 29,
    height: 29,
    viewBox: "0 0 29 29",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "content_copy_FILL0_wght400_GRAD0_opsz24 1"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M10.875 21.75C10.2104 21.75 9.64149 21.5133 9.16823 21.0401C8.69496 20.5668 8.45833 19.9979 8.45833 19.3333V4.83329C8.45833 4.16871 8.69496 3.59979 9.16823 3.12652C9.64149 2.65326 10.2104 2.41663 10.875 2.41663H21.75C22.4146 2.41663 22.9835 2.65326 23.4568 3.12652C23.93 3.59979 24.1667 4.16871 24.1667 4.83329V19.3333C24.1667 19.9979 23.93 20.5668 23.4568 21.0401C22.9835 21.5133 22.4146 21.75 21.75 21.75H10.875ZM10.875 19.3333H21.75V4.83329H10.875V19.3333ZM6.04167 26.5833C5.37708 26.5833 4.80816 26.3467 4.3349 25.8734C3.86163 25.4001 3.625 24.8312 3.625 24.1666V7.24996H6.04167V24.1666H19.3333V26.5833H6.04167Z",
    fill: "white"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCopycontent);
export default __webpack_public_path__ + "static/media/copycontent.019f47d51f174286acecdb1dbb4403a8.svg";
export { ForwardRef as ReactComponent };